<template>
    <div class="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <div class="px-4 pt-4 pb-2">
            <p class="text-lg font-bold text-slate-900">Photo après intervention</p>
            <p class="text-sm text-slate-500 mt-0.5">Documentez l'état de l'installation en fin d'intervention.</p>
        </div>

        <div class="p-4">
            <div v-if="currentImage" class="relative rounded-xl overflow-hidden bg-black mb-3" style="aspect-ratio: 4/3;">
                <img :src="currentImage" class="w-full h-full object-cover" alt="Photo fin" />
                <button
                    class="absolute top-2 right-2 w-8 h-8 bg-black/60 rounded-full flex items-center justify-center text-white"
                    @click="clearPhoto"
                >
                    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12" stroke-linecap="round"/></svg>
                </button>
            </div>

            <label
                v-if="!currentImage"
                class="flex flex-col items-center justify-center gap-3 py-8 rounded-xl cursor-pointer transition-colors"
                :class="currentImage
                    ? 'bg-gray-50 border border-dashed border-gray-300'
                    : 'bg-blue-50 border-2 border-dashed border-blue-300 hover:bg-blue-100'"
            >
                <input ref="fileInput" type="file" accept="image/*" capture="environment" class="hidden" @change="handleFileChange" />
                <svg class="w-10 h-10" :class="currentImage ? 'text-gray-400' : 'text-blue-400'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/>
                    <circle cx="12" cy="13" r="4"/>
                </svg>
                <span class="text-sm font-semibold" :class="currentImage ? 'text-gray-500' : 'text-blue-600'">
                    {{ currentImage ? 'Changer la photo' : 'Prendre une photo' }}
                </span>
            </label>

            <div v-if="currentImage" class="flex items-center gap-2 mt-3 px-3 py-2 bg-green-50 rounded-xl">
                <svg class="w-4 h-4 text-green-600 shrink-0" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5l-4-4 1.41-1.41L10 13.67l6.59-6.59L18 8.5l-8 8z"/></svg>
                <span class="text-sm text-green-700 font-medium">Photo enregistrée</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepPhotoFin',
    inject: ['wm'],

    computed: {
        currentImage() {
            return this.wm.formData.imageFinLocal ?? this.wm.formData.imageFin;
        },
    },

    methods: {
        handleFileChange(e) {
            const file = e.target.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (ev) => {
                this.wm.updateFormData({ imageFinLocal: ev.target.result, imageFin: null });
            };
            reader.readAsDataURL(file);
        },

        clearPhoto() {
            this.wm.updateFormData({ imageFinLocal: null, imageFin: null });
            if (this.$refs.fileInput) this.$refs.fileInput.value = '';
        },
    },
};
</script>
